/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_Item_5Inputs */

const es_privacy_policy_scope_item_5 = /** @type {(inputs: Privacy_Policy_Scope_Item_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos generados por su uso de nuestras funcionalidades`)
};

const en_privacy_policy_scope_item_5 = /** @type {(inputs: Privacy_Policy_Scope_Item_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data generated by your use of our features`)
};

/**
* | output |
* | --- |
* | "Data generated by your use of our features" |
*
* @param {Privacy_Policy_Scope_Item_5Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_item_5 = /** @type {((inputs?: Privacy_Policy_Scope_Item_5Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_Item_5Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_item_5(inputs)
	return en_privacy_policy_scope_item_5(inputs)
});
export { privacy_policy_scope_item_5 as "privacy_policy.scope.item_5" }